/* sns-drawer.js (QS fix 2026-10-19). The phone drawer ships only its top level items; this loads the nested
   submenus once, through the Section Rendering API (section sns-drawer-menu, rendered for the current path so the
   active item still marks), the first time the shopper reaches for the drawer. Each placeholder
   [data-sns-drawer-lazy] in snippets/header-drawer.liquid is replaced by the full submenu with the same ids and
   classes, and the new summaries and back buttons are bound to Dawn's header-drawer handlers. No scroll listeners
   (iOS taps emit scroll). On any failure the placeholders stay, and they link each item to its hub page. */
(function () {
  var drawer = document.querySelector('header-drawer[data-sns-menu]');
  if (!drawer || !window.fetch || !window.DOMParser) return;
  var main = drawer.querySelector('#Details-menu-drawer-container');
  if (!main || !drawer.querySelector('[data-sns-drawer-lazy]')) return;
  var state = 0; /* 0 idle, 1 loading, 2 done */
  var tries = 0;
  var BTN = 'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)';

  function bind(root) {
    if (typeof drawer.onSummaryClick !== 'function') return; /* not upgraded: native details still toggle */
    root.querySelectorAll('summary').forEach(function (s) { s.addEventListener('click', drawer.onSummaryClick.bind(drawer)); });
    root.querySelectorAll(BTN).forEach(function (b) { b.addEventListener('click', drawer.onCloseButtonClick.bind(drawer)); });
  }

  function apply(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('[data-sns-drawer-menu]');
    if (!root || root.getAttribute('data-sns-drawer-menu') !== drawer.getAttribute('data-sns-menu')) throw new Error('menu mismatch');
    var done = 0;
    drawer.querySelectorAll('[data-sns-drawer-lazy]').forEach(function (ph) {
      var key = ph.getAttribute('data-sns-drawer-lazy');
      var tpl = null;
      root.querySelectorAll('template[data-sns-drawer-sub]').forEach(function (t) { if (t.getAttribute('data-sns-drawer-sub') === key) tpl = t; });
      var src = tpl && tpl.content.firstElementChild;
      if (!src) return;
      var sub = document.importNode(src, true);
      var details = ph.parentNode;
      ph.replaceWith(sub);
      bind(sub);
      if (details.classList.contains('menu-opening') && typeof trapFocus === 'function') trapFocus(sub, sub.querySelector('button'));
      done++;
    });
    return done;
  }

  function load() {
    if (state !== 0 || tries >= 2) return;
    state = 1; tries++;
    fetch(window.location.pathname + '?sections=sns-drawer-menu', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        var n = apply(j && j['sns-drawer-menu'] || '');
        state = 2;
        drawer.setAttribute('data-sns-drawer', 'loaded:' + n);
      })
      .catch(function () { state = 0; drawer.setAttribute('data-sns-drawer', 'fallback'); });
  }

  var summary = main.querySelector('summary');
  if (summary) {
    ['pointerdown', 'touchstart', 'focus', 'mouseenter', 'click'].forEach(function (ev) {
      summary.addEventListener(ev, load, { passive: true });
    });
  }
  main.addEventListener('toggle', function () { if (main.open) load(); });
})();
